import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "app/components/button";
import { ConditionalButton } from "app/components/buttons";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { CardHeader } from "app/components/card-header";
import { Checkbox } from "app/components/checkbox";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Input } from "app/components/input";
import { RouteError } from "app/components/route-error";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import toast from "react-hot-toast";

const initialState = {
  importacion: {
    importacion_detalles: "",
    importacion_principal: false,
  },
  error: null,
};

export function ImportacionForm() {
  const params = useParams();
  const navigate = useNavigate();

  const { addImportacion, getImportacion, updateImportacion } = useEmpresa();

  const [state, setState] = useState(initialState);

  useEffect(() => {
    try {
      if (!!params.index) {
        const importacion = getImportacion(parseInt(params.index));

        setState((state) => ({ ...state, importacion }));
      }
    } catch (error) {
      setState((state) => ({ ...state, error }));
    }
  }, [params.index, getImportacion]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!params.index) {
        const updated = updateImportacion(
          parseInt(params.index),
          state.importacion
        );

        if (!!updated) {
          toast.success("Importación actualizada!");

          return navigate("../../");
        }
      } else {
        const added = addImportacion(state.importacion);

        if (!!added) {
          toast.success("Importación agregada!");

          return navigate("../../");
        }
      }
    } catch (error) {
      return toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${!!params.index ? "Editar" : "Agregar"} importación`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Input
                  placeholder="Detalles de la importación"
                  value={state.importacion.importacion_detalles}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      importacion: {
                        ...state.importacion,
                        importacion_detalles: e.target.value,
                      },
                    }))
                  }
                  autoFocus
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es una importación principal?"
                  checked={state.importacion.importacion_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      importacion: {
                        ...state.importacion,
                        importacion_principal: e.target.checked,
                      },
                    }))
                  }
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              outline
              title="Cancelar"
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
